import axios from "axios";

export default {
  async create(formData) {

    const files = new FormData();
    for (let i=0; i<formData.files.length; i+=1) {
      files.append("files", formData.files[i]);
    }

    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return axios.post(`/rent-object-images/rent-objects/${formData.id}`, files, config);
  },
  async update(formData) {
    return axios.put(`/rent-object-images/${formData.id}`, formData);
  },
  async updateWebsiteOrder(formData) {
    return axios.put(`/rent-object-images/${formData.id}/order-website`, formData);
  },
  async updateOfferOrder(formData) {
    return axios.put(`/rent-object-images/${formData.id}/order-offer`, formData);
  },
  async findAll(formData) {
    return axios.get(`/rent-object-images/rent-objects/${formData.id}`);
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-images/${id}`);
  }
};